// extracted by mini-css-extract-plugin
export var dividerLine = "_4k-0";
export var errorBackground = "_4k-1";